export var ElementId;
(function (ElementId) {
    ElementId["WalletModalContent"] = "widget-wallet-modal-content";
    ElementId["WalletConnectElement"] = "w3m-modal";
})(ElementId || (ElementId = {}));
const getWalletModalContentElement = () => document.getElementById(ElementId.WalletModalContent);
const getWalletConnectElement = () => document.querySelector(ElementId.WalletConnectElement);
export const createWalletConnectElement = () => {
    const elementExists = getWalletConnectElement();
    if (!elementExists) {
        const modal = document.createElement(ElementId.WalletConnectElement);
        const containerElement = getWalletModalContentElement();
        containerElement?.parentElement?.insertAdjacentElement('afterbegin', modal);
    }
};
//# sourceMappingURL=elements.js.map